<template>
	<div class="panel">
		<div class="container">
			<div class="panel_header">
				<div class="row align-items-end">
					<div class="col-12">
						<h2>Партнеры список</h2>
					</div>
				</div>
				<!-- <nuxt-link class="panel_control" to="#"></nuxt-link> -->
			</div>
			<div class="partners-block">
				<ul class="partners-list row">
					<li class="col-12 col-sm-6 col-lg-3">
						<div class="partner">
							<div class="logo">
								<img src="/tmp/partner_logo_1.png" />
							</div>
							<div class="description">
								<p>Мы благодарим банк UBS за многолетнюю поддержку деятельности Центра</p>
							</div>
						</div>
					</li>
					<li class="col-12 col-sm-6 col-lg-3">
						<div class="partner">
							<div class="logo">
								<img src="/tmp/partner_logo_2.png" />
							</div>
							<div class="description">
								<p>Мы благодарим RVVZ Foundation за поддержку деятельности Центра</p>
							</div>
						</div>
					</li>
					<li class="col-12 col-sm-6 col-lg-3">
						<div class="partner">
							<div class="logo">
								<img src="/tmp/partner_logo_3.png" />
							</div>
							<div class="description">
								<p>Мы благодарим Phoenix Advisors за поддержку деятельности Центра</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "partners-list",
		// props: ["content", "static_content", "block_title", "fetchedData", "block"],
		data() {
			return {
				modalContent: null
			};
		}
	};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-partners-list";
</style>
